import { user } from '../Types/user'

export const getUsersByRole = (userList: user[], role: string) => {
  const roleUsers = userList.filter((user) => user.role === role)
  return roleUsers.map((user) => {
    return { value: user.email, label: user.first_name + ' ' + user.last_name }
  })
}
